(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CronogramaFungicidasGridCtrl', CronogramaFungicidasGridController);

  CronogramaFungicidasGridController.$inject = [
    'MessagesService',
    'LoadingService',
    'CronogramaFungicidasService',
    'RecomendacoesService',
    '$scope',
    '$uibModal',
    '$rootScope',
    '$location',
    '$route',
    'AplicacoesService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function CronogramaFungicidasGridController(MessagesService, LoadingService, CronogramaFungicidasService,
    RecomendacoesService, $scope, $uibModal, $rootScope, $location, $route, AplicacoesService) {
    const DAYS_TO_BE_SOON = 3;
    const vm = this;
    const STATUS_APLICACAO = ['applied', 'in_progress'];

    // Controller data
    vm.scheduleForDuplication = null;
    vm.showModalAplicacao = false;
    vm.duplicationTargets = [];
    vm.aplicacao = null; // aplicação aberta em modal para ver detalhes
    vm.summaryActive = null;
    vm.isDropdownAplicacaoOpen = false;
    vm.parameter = null;
    vm.modalVinculandoAplicacao = null;
    vm.modalDetails = null;
    vm.sortableOptions = {
      handle: '.heading',
      stop: function() {
        const promises = vm.schedules.map(function(s, index) {
          s.ordem = index + 1;
          return CronogramaFungicidasService.updateSchedule(s.id, s);
        });

        LoadingService.showLoading();
        Promise.all(promises)
          .finally(LoadingService.hideLoading)
          .catch(function(error) {
            console.error(error);
            MessagesService.alert('Erro ao reordenar');
          });
      }
    };

    // Bindable methods
    vm.parameterClasses = parameterClasses;
    vm.wasAppliedLate = wasAppliedLate;
    vm.fixAbreviatura = _.memoize(fixAbreviatura);
    vm.deleteSchedule = deleteSchedule;
    vm.duplicateSchedule = duplicateSchedule;
    vm.glebasAvailableForDuplication = glebasAvailableForDuplication;
    vm.openDetails = openDetails;
    vm.editSchedule = editSchedule;
    vm.goToRecommendation = goToRecommendation;
    vm.hideRecommendationButton = hideRecommendationButton;
    vm.summaries = [];
    vm.openSummary = openSummary;
    vm.diffDays = diffDays;
    vm.atividades = [];
    vm.openAplicacoes = openAplicacoes;
    vm.applications = [];
    vm.aplicacao = null;
    vm.vinculaAplicacao = vinculaAplicacao;
    vm.desvincular = desvincular;
    vm.finalizaCronogramaFungicidaParameter = finalizaCronogramaFungicidaParameter;
    vm.hasValidRecommendation = hasValidRecommendation;

    // Function declarations
    function parameterClasses(parameter) {
      let result = '';

      if (parameter.status === 'delayed') {
        result = 'parameter-delayed';
      } else if (parameter.status === 'will_not_perform') {
        result = 'parameter-discarded';
      } else if (parameter.status === 'applied') {
        result = 'parameter-applied';
      } else if (parameter.status === 'in_progress') {
        result = 'parameter-in-progress';
      } else if (moment(parameter.data_estimada).diff(moment().startOf('day'), 'days') <= DAYS_TO_BE_SOON) {
        result = 'parameter-soon';
      }

      return result;
    }

    function wasAppliedLate(parameter) {
      if (parameter.status === 'applied') {
        const { data_estimada: estimatedDate, data_fim_aplicacao: appliedDate } = parameter;

        return moment(appliedDate).isAfter(estimatedDate);
      }
      return false;
    }

    function fixAbreviatura(abreviatura) {
      return abreviatura.trim().toLowerCase();
    }

    function deleteSchedule(schedule) {
      return MessagesService.confirm('Você tem certeza que deseja apagar o cronograma? Isso não pode ser desfeito!')
        .then(() => {
          LoadingService.showLoading();
          return CronogramaFungicidasService.deleteSchedule(schedule);
        })
        .then(() => {
          MessagesService.alert('Cronograma excluído com sucesso!');
          loadSchedules();
        })
        .catch((error) => {
          if (error && typeof error !== 'string') {
            MessagesService.alert('Não foi possível excluir o cronograma, tente novamente');
            console.error(error);
          }
        })
        .finally(LoadingService.hideLoading);
    }

    function loadSchedules() {
      vm.onUpdate();
    }

    function duplicateSchedule(schedule) {
      vm.scheduleForDuplication = schedule;
      getAtividadesPeriodo();

      const modal = $uibModal.open({
        scope: $scope,
        templateUrl: 'views/cronograma_fungicidas/duplication.html'
      });
      modal.result
        .then(() => {
          LoadingService.showLoading();
          return CronogramaFungicidasService.duplicateSchedule(schedule.id, _.flatMap(vm.duplicationTargets, 'id'));
        })
        .then(() => {
          loadSchedules();
        })
        .catch((error) => {
          if (error && typeof error !== 'string') {
            MessagesService.alert('Erro ao duplicar cronograma, tente novamente mais tarde.');
            console.error(error);
          }
        })
        .finally(() => {
          vm.duplicationTargets = [];
          LoadingService.hideLoading();
        });
      modal.closed.then(() => {
        vm.scheduleForDuplication = null;
      });
    }

    function glebasAvailableForDuplication() {
      const { atividade: cronogramaAtividade } = vm.scheduleForDuplication;
      const atividade = vm.atividades.find((atividadePeriodo) => atividadePeriodo.id === cronogramaAtividade.id);
      let availableGlebas = [];

      if (atividade) {
        availableGlebas = RecomendacoesService.listGlebas(atividade.glebas);
      } else {
        availableGlebas = $rootScope.currentPropriedade.glebas;
      }

      return availableGlebas;
    }

    function openDetails(parameter) {
      vm.parameter = parameter;
      vm.modalDetails = $uibModal.open({
        scope: $scope,
        templateUrl: 'views/cronograma_fungicidas/modal-details.html'
      });
      vm.modalDetails.closed.then(() => {
        vm.parameter = null;
      });
    }

    function abrirDropdown(parameter) {
      const alturaDiv = (parameter * 23) + 170;
      const novaAlturaDiv = Math.min(alturaDiv, 745);
      const novaMargemBotao = Math.min((alturaDiv - 164), 580);

      vm.onDropdownOpen = () => {
        vm.isDropdownAplicacaoOpen = true;
        angular.element('.modal-aplicacoes').addClass('modal-expande');

        const modal = document.querySelector('.modal-expande');
        modal.style.height = `${novaAlturaDiv}px`;

        const botao = document.querySelector('.btn-success');
        botao.style.marginTop = `${novaMargemBotao}px`;
      };

      vm.onDropdownClose = () => {
        vm.isDropdownAplicacaoOpen = false;
        const modalAplicacoes = angular.element('.modal-aplicacoes');
        modalAplicacoes.removeClass('modal-expande');
        modalAplicacoes.removeAttr('style');
        const botao = document.querySelector('.btn-success');
        botao.style.marginTop = '';
      };

      angular.element(document.getElementById('dropdown-aplicacoes')).on('DOMSubtreeModified', function() {
        const isOpen = angular.element('#dropdown-aplicacoes').hasClass('open');

        if (!isOpen) {
          vm.onDropdownClose();
        }
      });
    }

    // eslint-disable-next-line max-lines-per-function
    function openAplicacoes(parameter, schedule) {
      vm.parameter = parameter;
      LoadingService.showLoading();
      CronogramaFungicidasService.aplicacoesNaoVinculadas({
        gleba: schedule.gleba.id,
        atividade: schedule.atividade.id,
        safra: schedule.safra.id,
        operacao: $rootScope.parametros.operacao_pulverizacao.id
      }).then(function(result) {
        if (!result.data.length) {
          MessagesService.alert('Nenhuma aplicação encontrada.');
          vm.modalVinculandoAplicacao.close();
        }
        vm.applications = result.data;
        const quantidadeResultado = vm.applications.length;
        abrirDropdown(quantidadeResultado);
        LoadingService.hideLoading();
        vm.showModalAplicacao = true;
        angular.element('.modal-dialog').css('width', '60%');
      })
        .catch(function(error) {
          console.error('Erro ao carregar aplicações', error);
          MessagesService.alert('Erro ao carregar aplicações');
          vm.modalVinculandoAplicacao.close();
        });
      vm.modalVinculandoAplicacao = $uibModal.open({
        scope: $scope,
        templateUrl: 'views/cronograma_fungicidas/modal-aplicacoes.html'
      });
      vm.modalVinculandoAplicacao.closed.then(() => {
        vm.parameter = null;
        vm.aplicacao = null;
        vm.dropdownOpen = false;
        vm.showModalAplicacao = false;
        angular.element('.modal-dialog').css('width', '');
      });
    }

    function vinculaAplicacao() {
      AplicacoesService.vinculaAplicacaoCronograma({
        aplicacao_id: vm.aplicacao.id,
        cronograma_fungicida_parameter_id: vm.parameter.id
      }).then(() => {
        loadSchedules();
      })
        .catch(function(error) {
          console.error('Erro ao vincular aplicação', error);
          MessagesService.alert('Erro ao vincular aplicação');
        })
        .finally(() => {
          vm.modalVinculandoAplicacao.close();
        });
    }

    function desvincular(aplicacao) {
      MessagesService.confirm('Você realmente deseja desvincular essa aplicação?').then(function() {
        AplicacoesService.desvinculaAplicacaoCronograma({
          aplicacao_id: aplicacao.id,
          cronograma_fungicida_parameter_id: vm.parameter.id
        }).then(() => {
          loadSchedules();
        })
          .catch(function(error) {
            console.error('Erro ao desvincular aplicação', error);
            MessagesService.alert('Erro ao desvincular aplicação');
          })
          .finally(() => {
            vm.modalDetails.close();
          });
      });
    }

    function finalizaCronogramaFungicidaParameter(id) {
      MessagesService.confirm('Deseja realmente finalizar essa aplicação?').then(function() {
        AplicacoesService.finalizaCronogramaFungicidaParameter({
          parameter_id: id
        }).then(() => {
          loadSchedules();
        })
          .catch(function(error) {
            console.error('Erro ao finalizar aplicação', error);
            MessagesService.alert('Erro ao finalizar aplicação');
          });
      });
    }

    function openSummary(summary) {
      vm.summaryActive = summary;
      const modal = $uibModal.open({
        scope: $scope,
        templateUrl: 'views/cronograma_fungicidas/modal-sumary.html',
        size: 'lg'
      });
      modal.closed.then(() => {
        vm.summaryActive = null;
      });
    }

    function editSchedule(schedule) {
      vm.scheduleForEdition = schedule;
      const modal = $uibModal.open({
        resolve: {
          schedule: () => schedule
        },
        templateUrl: 'views/cronograma_fungicidas/edition.html',
        controller: 'CronogramaFungicidaEditionCtrl',
        controllerAs: '$ctrl'
      });
      modal.result
        .catch((error) => {
          console.error(error);
        })
        .finally(loadSchedules);
    }

    function goToRecommendation(schedule, parameter, event) {
      preventDefault(event);
      if (hasValidRecommendation(parameter)) {
        redirectToShowRecommendation(schedule, parameter);
      } else {
        redirectToAddRecommendation(schedule, parameter);
      }
      $location.path('/propriedade');
    }

    function hasValidRecommendation(parameter) {
      return (parameter.recomendacao || {}).id && !parameter.recomendacao.eliminado;
    }

    function redirectToAddRecommendation(schedule, parameter) {
      $route.updateParams({
        sidebar: 'addRecommendation',
        redirect: 'cronogramaFungicidas',
        recommendationParams: JSON.stringify({
          cronogramaFungicidaParameterId: parameter.id,
          atividade: schedule.atividade.id,
          gleba: schedule.gleba.id,
          safra: schedule.safra.id,
          dataInicial: parameter.data_estimada,
          observacao: parameter.observacoes,
          produtos: parameter.items.map((item) => ({
            id: item.item_estoque.id[1],
            descricao: item.item_estoque.descricao,
            dose: +item.dose,
            unidade: {
              descricao: item.unidade.descricao
            }
          }))
        })
      });
    }

    function redirectToShowRecommendation(schedule, parameter) {
      $route.updateParams({
        sidebar: 'recommendations',
        activeRecommendation: parameter.recomendacao.id,
        recommendationFilters: JSON.stringify({
          gleba: schedule.gleba.id,
          dataInicial: parameter.recomendacao.data_inicio,
          dataFinal: parameter.recomendacao.data_termino
        })
      });
    }

    function hideRecommendationButton(parameter) {
      return parameter.status === 'will_not_perform' || parameter.status === 'applied';
    }

    function diffDays(dataEmergencia, dataAplicacao) {
      return moment(dataAplicacao).diff(moment(dataEmergencia), 'days');
    }

    // PRIVATE FUNCTIONS

    // eslint-disable-next-line max-lines-per-function,
    function getSummariesSchedule(schedules) {
      const summaries = schedules.reduce((details, schedule) => {
        // eslint-disable-next-line camelcase
        const { gleba, dias_intervalo } = schedule;

        schedule.parameters.forEach((parameter, index) => {
          const { recomendacao } = parameter;
          const difDateAplicacaoRecomendacao = parameter.data_fim_aplicacao && recomendacao ?
            vm.diffDays(parameter.data_fim_aplicacao, recomendacao.data_inicio) : null;

          const dataFinal = STATUS_APLICACAO.includes(parameter.status) ?
            parameter.data_fim_aplicacao : parameter.data_estimada;
          const posicaoCiclo = dataFinal && vm.diffDays(schedule.data_emergencia, dataFinal);
          const diasEntreEmergenciaEAplicacao = parameter.data_fim_aplicacao &&
            vm.diffDays(schedule.data_emergencia, parameter.data_fim_aplicacao);
          const parameters = {
            ...parameter,
            difDateAplicacaoRecomendacao,
            gleba,
            posicaoCiclo,
            diasEntreEmergenciaEAplicacao,
            dias_intervalo
          };

          details[index] = details[index] || {
            numeroAplicacao: index + 1,
            average: {},
            parameters: []
          };
          details[index].parameters.push(parameters);
        });

        return details;
      }, []);

      summaries.forEach((summary) => summary.average = getAverageSummary(summary));

      vm.summaries = summaries;
    }

    function getAtividadesPeriodo() {
      const { safra } = vm.scheduleForDuplication;

      if (safra) {
        LoadingService.showLoading();
        const filters = {
          safra: (safra || {}).id,
          propriedade: $rootScope.currentPropriedade.id
        };

        RecomendacoesService.listAtividadesPeriodo(filters)
          .then(function(data) {
            vm.atividades = data;
          })
          .catch(function() {
            MessagesService.alert('Ocorreu um erro ao buscar as culturas da safra selecionada.');
          })
          .finally(LoadingService.hideLoading);
      }
    }

    function getAverageSummary(summary) {
      // difDateAplicacaoRecomendacao

      // Necessário para ignorar os elementos que não tem recomendação ou aplicação
      const summaryDiffAplication = summary.parameters.filter(({ difDateAplicacaoRecomendacao }) => (
        _.isNumber(difDateAplicacaoRecomendacao)
      ));

      const sumDifDateAplicacaoRecomendacao = summaryDiffAplication.reduce((total, summaryDiff) => (
        total += summaryDiff.difDateAplicacaoRecomendacao
      ), 0);

      let difDateAplicacaoRecomendacao = null;

      if (sumDifDateAplicacaoRecomendacao && summaryDiffAplication.length) {
        difDateAplicacaoRecomendacao = sumDifDateAplicacaoRecomendacao / summaryDiffAplication.length;
      }

      // diasIntervalo
      let sumDiasIntervalo = 0;

      summary.parameters.forEach((value) => sumDiasIntervalo += value.dias_intervalo);

      const diasIntervalo = sumDiasIntervalo / summary.parameters.length;

      // posicaoCiclo
      const validsPosicaoCiclo = summary.parameters.filter(({ posicaoCiclo }) => (
        _.isNumber(posicaoCiclo)
      ));

      const sumPosicaoCiclo = validsPosicaoCiclo.reduce((total, { posicaoCiclo }) => total += posicaoCiclo, 0);
      let posicaoCiclo = null;

      if (validsPosicaoCiclo.length) {
        posicaoCiclo = sumPosicaoCiclo / validsPosicaoCiclo.length;
      }

      const average = {
        difDateAplicacaoRecomendacao,
        diasIntervalo,
        posicaoCiclo
      };

      return average;
    }

    // Controller logic
    vm.$onChanges = function $onChanges(changes) {
      if (changes.schedules && !changes.schedules.isFirstChange()) {
        getSummariesSchedule(changes.schedules.currentValue);
      }
    };
  }
}());
